import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import type { PaginatedData } from '#src/app/shared/contexts/asyncData';

import type { LocationSitemapDataQuery, LocationSitemapDataQueryVariables } from './api.graphql';
import { LocationSitemapData } from './api.graphql';
import type { LocationSitemapItem } from './types';

/** @knip-ignore */
export type UsState = { stateCode: string; displayName: string };
export type LocationSitemapPageData = PaginatedData<
	LocationSitemapItem,
	{ totalCount: number; states: readonly UsState[] }
>;
export type Locations = LocationSitemapDataQuery['locations']['nodes'];

async function getData(
	{ gql: { fetch } }: UtilityContext,
	queryParams: { stateCode?: string | undefined },
	cursor?: string,
): Promise<LocationSitemapPageData> {
	const { data } = await fetch<LocationSitemapDataQuery, LocationSitemapDataQueryVariables>({
		query: LocationSitemapData,
		variables: { cursor: cursor ?? null, stateCode: queryParams.stateCode ?? null },
		rejectOnError: true,
	});

	return {
		items: data.locations.nodes,
		cursor: data.locations.pageInfo.endCursor,
		hasNextPage: data.locations.pageInfo.hasNextPage,
		totalCount: data.locations.totalCount,
		states: data.country?.states ?? [],
	};
}

export async function getFirstPageData(
	utilityContext: UtilityContext,
	queryParams: { stateCode?: string | undefined },
) {
	return getData(utilityContext, queryParams);
}
export async function getNextPageData(
	utilityContext: UtilityContext,
	cursor: string,
	queryParams: { stateCode?: string | undefined },
) {
	return getData(utilityContext, queryParams, cursor);
}
